<template>
    <user-header></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <user-tabset></user-tabset>
  
    <div class="content court-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="court-tab-content">
              <div class="card card-tableset">
                <div class="card-body">
                  <div class="coache-head-blk">
                    <div class="row align-items-center">
                      <div class="col-md-5">
                        <div class="court-table-head">
                          <h4>Trận  đấu của bạn</h4>
                          <p>Xem lịch thi đấu của bạn</p>
                        </div>
                      </div>
                      <div class="col-md-7">
                        <div class="table-search-top">
                          <div id="tablefilter">
                            <div class="dataTables_filter">
                              <label> 
                                  <input type="search" class="form-control form-control-sm" placeholder="Tìm kiếm" aria-controls="DataTables_Table_0">
                              </label>
                            </div>
                          </div>
                          <div class="request-coach-list">
                            <div class="card-header-btns">
                              <nav>
                                <div class="nav nav-tabs" role="tablist">
                                  <button class="nav-link active" id="nav-Recent-tab" data-bs-toggle="tab"
                                    data-bs-target="#nav-Recent" type="button" role="tab" aria-controls="nav-Recent"
                                    aria-selected="true">
                                    Giải đấu
                                  </button>
                                </div>
                              </nav>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-content">
                    <match-table></match-table>
                  </div>
                </div>
              </div>
              <div class="tab-footer">
                <div class="row">
                  <div class="col-md-6">
                    <div id="tablelength">
                      <div class="dataTables_length" id="DataTables_Table_0_length">
                        <label>Hiển thị
                          <select class="custom-select custom-select-sm form-control form-control-sm">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="-1">All</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div id="tablepage">
                      <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a
                              href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                              class="page-link"><i class="feather-chevrons-left"></i></a></li>
                          <li class="paginate_button page-item active"><a href="javascript:void(0);"
                              aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a></li>
                          <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next"><a
                              href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                              class="page-link"><i class="feather-chevrons-right"></i></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <layout-footer></layout-footer>
    <user-booking-modal></user-booking-modal>
  </template>
  <script>
  export default {
    data() {
      return {
        title: "Trận đấu",
        text: "Trang chủ",
        text1: "Trận đấu",
        Week: ["This Week", "One Day"],
        Relevance: ["Relevance", "Price"],
      };
    },
  };
  </script>
  